import CircleCalendar from '../assets/circles/Calendar';
import CircleCheck from '../assets/circles/Check';
import CircleDefault from '../assets/circles/Default';
import CircleDownload from '../assets/circles/Download';
import CircleFacebook from '../assets/circles/Facebook';
import CircleInstagram from '../assets/circles/Instagram';
import CircleLove from '../assets/circles/Love';
import CircleMapMarker from '../assets/circles/MapMarker';
import CircleThumbUp from '../assets/circles/ThumbUp';
import CircleUser from '../assets/circles/User';

function getProgramColorScheme(theme) {
  return {
    bodyBg: theme?.appBackColor || '#ffffff',
    bodyText: theme?.appForeColor || 'rgba(79,79,77)',
    primary: theme?.primaryColor || '#FD6805',
    primaryContrast: theme?.primaryContrastColor || '#ffffff',
    secondary: theme?.secondaryColor || '#747474',
    secondaryContrast: theme?.secondaryContrastColor || '#ffffff',
    success: theme?.successColor || '#3EB036',
    successContrast: theme?.successContrastColor || '#ffffff',
    danger: theme?.dangerColor || '#E63E3E',
    dangerContrast: theme?.dangerContrastColor || '#ffffff',
    warning: theme?.warningColor || '#F9E000',
    warningContrast: theme?.warningContrastColor || '#000000',
    info: theme?.infoColor || '#4269FF',
    infoContrast: theme?.infoContrastColor || '#ffffff',
    light: theme?.lightColor || '#EFEFEF',
    lightContrast: theme?.lightContrastColor || '#000000',
    dark: theme?.darkColor || '#181E36',
    darkContrast: theme?.darkContrastColor || '#ffffff',
    disable: theme?.disabledColor || '#CECECE',
    backdrop: theme?.backdropColor || '#323232B3',
    overlay: theme?.overlayColor || '#00000066',
    white: '#fff',
    black: '#000',
    grey: '#eee',
    darkGrey: '#4F4F4D',
    transparent: 'transparent'
  };
}

function renderCircleIcon(icon, title = null) {
  switch (icon) {
    case 'calendar':
      return <CircleCalendar title={title} />;
    case 'check':
      return <CircleCheck title={title} />;
    case 'map_marker':
      return <CircleMapMarker title={title} />;
    case 'user':
      return <CircleUser title={title} />;
    case 'download':
      return <CircleDownload title={title} />;
    case 'facebook':
      return <CircleFacebook title={title} />;
    case 'instagram':
      return <CircleInstagram title={title} />;
    case 'love':
      return <CircleLove title={title} />;
    case 'thumbup':
      return <CircleThumbUp title={title} />;
    default:
      return <CircleDefault title={title} />;
  }
}

function createElement(type, props) {
  const el = document.createElement(type);
  for (const key in props) {
    if (key === 'style') {
      for (const styleKey in props[key]) {
        el.style[styleKey] = props[key][styleKey];
      }
    } else if (key === 'className') {
      el.setAttribute('class', props[key]);
    } else {
      el.setAttribute(key, props[key]);
    }
  }
  return el;
}

export {
  getProgramColorScheme,
  renderCircleIcon,
  createElement
};